import React, { useEffect } from 'react';
import { VLink } from "./AppDataContext";
import { Helmet } from "react-helmet";

export function About() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
        <Helmet>
            <title>About Us</title>
        </Helmet>
            <main class="content-page">
            <section> 
            <div class="container">
                <div class="row">
                    <div class="col-12 py-5">
                        <h1 class="h3">Meet Bid Next Door </h1>
                        <div class="divider mt-2"></div>
                        <h1 class="h4 mb-4   "><i>Auctions designed with <strong>you</strong> in mind</i></h1>
                        <p>
                            Welcome to Bid Next Door: an auction marketplace connecting buyers and sellers of local estate merchandise. Our journey started in 2020 and was motivated by the estate sale industry’s growing need for a comprehensive inventory and marketplace solution. Created by auction industry professionals, Bid Next Door was thoughtfully designed to streamline every step of the process involved in managing and shopping estate sales.
                        </p>
                        <p>
                            For buyers, we are a local resource for finding untold treasures in your neighborhood.
                        </p>
                        <p>
                            <i>To stay informed about new estate auction listings, subscribe to our mailing list.</i>
                        </p>
                        <p>
                            For auction houses and estate sale professionals, we are an all-in-one software solution to help you run your business as smoothly and efficiently as possible, helping you and your clients expose the treasures you find every day to the most relevant local buyers.
                        </p>
                        <p>
                            <i>To learn more about selling on Bid Next Door, <VLink to="/sell">get in touch with our Partnerships team.</VLink></i>
                        </p>
                        <p>
                            For estates and people with items to sell, we are a marketplace designed to connect your merchandise with its best new owner at the best possible price.
                        </p>
                        <p>
                            <i>For help finding a recommended and reputable estate sale company in your area, <VLink to="/contact">contact us.</VLink></i>
                            </p>
                            
                    </div>
                </div>
                </div>
            </section>
            
        </main>
        <section class="seller">
                <div class="container">
                    <div class="row align-items-center py-5 mt-5">
                        <div class="col seller--image justify-content-center">
                            <img src="images/top-banner-vector.png" alt="" title="" class="mx-auto w-100" />
                        </div>
                        <div class="col col-md-8 seller--content">
                            <div class="mx-auto py-3 px-3 py-md-5 px-md-5 seller--content__div">
                                <h4>Start Today!</h4>
                                <h2>Find TREASURES in YOUR Neighborhood</h2>
                                
                            </div>
                        </div>

                    </div>
                </div>
            </section></>
    );

}
